define('Balance.View.Extension', [
  'Balance.Model',
  'Balance.View',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  BalanceModel,
  BalanceView,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(BalanceView.prototype, {
    initialize: _.wrap(BalanceView.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      this.depositsum = new BalanceModel();
      this.depositsum.fetch();
      this.depositsum.on('change', this.render, this);
    }),

    getContext: _.wrap(BalanceView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var depSum = this.depositsum.get('depositSumFormatted');

      if (depSum) {
        context.depositsRemainingFormatted = depSum;
      }

      return context;
    })
  });
});
